import { Controller } from "@hotwired/stimulus";

// Mirrors Monster#dynamic_pv: when DV is a plain non-negative integer, PV is
// computed (DV × 5, or 2 when DV is 0) and shown read-only. Otherwise (a
// non-numeric DV like "Especial", or a blank DV) PV is entered manually.
// Connects to data-controller="monster-pv"
export default class extends Controller {
	static targets = ["dv", "dvBonus", "pv", "hint"];
	static values = { autoHint: String, manualHint: String };

	connect() {
		this.update();
	}

	update() {
		if (/^\d+$/.test(this.dvTarget.value)) {
			const dv = Number.parseInt(this.dvTarget.value, 10);
			const dvBonus = this.dvBonusTarget.value;
			const bonus = /^[+-]?\d+$/.test(dvBonus) ? Number.parseInt(dvBonus, 10) : 0;

			this.pvTarget.value = dv === 0 ? 2 + bonus : dv * 5 + bonus;
			this.pvTarget.readOnly = true;
			this.pvTarget.required = false;
			this.hintTarget.textContent = this.autoHintValue;
		} else {
			// Only a computed PV goes stale; a hand-entered one (DV "Especial") must survive the page load.
			if (this.pvTarget.readOnly) this.pvTarget.value = "";
			this.pvTarget.readOnly = false;
			this.pvTarget.required = true;
			this.hintTarget.textContent = this.manualHintValue;
		}
	}
}
